import React from 'react';
export const FinalSection = () => {
  return <section className="w-full py-16 bg-white" data-id="element-92">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-93">
        <p className="text-xl font-serif mb-8" data-id="element-94">Twoja Magda ❤️</p>
        <div className="mb-12" data-id="element-95">
          <p className="text-xl italic font-script text-gray-700" data-id="element-96">
            P.S. Za 6 miesięcy będziesz w jednym z dwóch miejsc...
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-97">
          <div className="bg-gray-100 p-6 rounded-lg shadow-md transform transition-all hover:scale-105" data-id="element-98">
            <h3 className="text-xl font-bold text-gray-700 mb-4" data-id="element-99">
              Niewidzialna i samotna
            </h3>
            <p className="text-gray-600" data-id="element-100">
              Nadal będziesz czuć się jak duch we własnym domu. Ignorowana,
              niedoceniana, niekochana. Każdy dzień będzie taki sam.
            </p>
            <div className="mt-4 w-full h-1 bg-red-200" data-id="element-101"></div>
          </div>
          <div className="bg-green-100 p-6 rounded-lg shadow-md transform transition-all hover:scale-105" data-id="element-102">
            <h3 className="text-xl font-bold text-green-700 mb-4" data-id="element-103">
              Kochana i szanowana
            </h3>
            <p className="text-gray-600" data-id="element-104">
              Twój mąż znów będzie patrzył na Ciebie z miłością. Będziesz czuć
              się doceniana, kochana, szczęśliwa.
            </p>
            <div className="mt-4 w-full h-1 bg-green-400" data-id="element-105"></div>
          </div>
        </div>
        <div className="mt-12" data-id="element-106">
          <a href="https://sklep.veiramode.com/products/od-frustracji-do-sily-psychologiczny-przewodnik-przez-kryzys-malzenski" className="bg-red-600 hover:bg-red-700 text-white text-xl font-bold py-3 px-6 rounded-lg shadow-lg transform transition-all hover:scale-105 inline-block" data-id="element-107">
  Decyzja należy do Ciebie - ODBIERZ TERAZ
        </a>
        </div>
      </div>
    </section>;
};